<template>
	<div>
		<Navigation></Navigation>

		<div class="bg_color_2" id="hero_register">
			<div class="container margin_60_35">
				<div class="row">
					<div class="col-lg-6">
						<h1>ENCONTRÁ TU ESPECIALISTA</h1>
						<p class="lead mt-3">
							En DoctorConsultas encontrás una gran variedad de especialistas comprometidos a solucionar tus necesidades médicas.
						</p>
						<p class="lead">
							Tu salud y tu tiempo valen mucho, por eso trabajamos para acortar tu tiempo de espera y que recibas un servicio de gran
							calidad.
						</p>
						<p class="lead">
							Registrate y reservá tu consulta rápido y fácil.
						</p>
					</div>
					<!-- /col -->
					<div class="col-lg-5 ml-auto">
						<div class="box_form">
							<form @submit.prevent="register" :disabled="loading">
								<div class="row">
									<label>Datos personales</label>
								</div>

								<div class="row">
									<div class="col-lg-12">
										<div class="form-group">
											<!-- <label>Nombre</label> -->
											<input
												type="text"
												class="form-control"
												placeholder="Nombre"
												v-model="form.name"
												:class="{ 'is-invalid': validationErrors['data.name'] }"
											/>
											<div class="invalid-feedback">{{ validationErrors['data.name'] }}</div>
										</div>
									</div>
									<div class="col-lg-12">
										<div class="form-group">
											<!-- <label>Apellido</label> -->
											<input
												type="text"
												class="form-control"
												placeholder="Apellido"
												v-model="form.lastname"
												:class="{ 'is-invalid': validationErrors['data.lastname'] }"
											/>
											<div class="invalid-feedback">{{ validationErrors['data.lastname'] }}</div>
										</div>
									</div>
									<div class="col-12">
										<div class="form-group input-group">
											<select
												class="form-control"
												v-model="form.doc_type"
												@change="validateCI()"
												:class="{ 'is-invalid': validationErrors['data.doc_number'] }"
											>
												<option value="CI">CI</option>
												<option value="Passport">Documento</option>
											</select>
											<input
												type="text"
												class="form-control"
												placeholder="N de documento"
												v-model="form.doc_number"
												@keyup="validateCI()"
												:class="{ 'is-invalid': validationErrors['data.doc_number'] }"
											/>
											<div class="invalid-feedback">{{ validationErrors['data.doc_number'] }}</div>
										</div>
									</div>
								</div>

								<div class="row">
									<div class="col-lg-12">
										<div class="form-group">
											<!-- <label>Teléfono</label> -->
											<input
												type="text"
												class="form-control"
												placeholder="Celular"
												v-model="form.phone"
												:class="{ 'is-invalid': validationErrors['data.phone'] }"
											/>
											<div class="invalid-feedback">{{ validationErrors['data.phone'] }}</div>
										</div>
									</div>
								</div>

								<div class="row">
									<label>Residencia</label>
								</div>

								<div class="row">
									<div class="col-lg-12">
										<div class="form-group">
											<select
												class="form-control"
												:disabled="loadingCountries"
												v-model="form.address_country_id"
												@change="
													hasChanges = true
													countryChanged()
												"
												:class="{ 'is-invalid': validationErrors['data.address_country_id'] }"
											>
												<option value="0">País</option>
												<option v-for="country in countries" :key="country.id" :value="country.id">{{ country.name }}</option>
											</select>
											<small v-if="loadingCountries">Cargando paises...</small>
											<div class="invalid-feedback">{{ validationErrors['data.address_country_id'] }}</div>
										</div>
									</div>
								</div>

								<div class="row" v-if="form.address_country_iso != 'UY'">
									<div class="col-lg-12">
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												placeholder="Ciudad, Localidad, Dirección"
												v-model="form.address_comments"
												@change="hasChanges = true"
											/>
										</div>
									</div>
								</div>

								<div class="row" v-if="form.address_country_iso == 'UY'">
									<div class="col-lg-12">
										<div class="form-group">
											<!-- <label>Ciudad</label> -->
											<select
												class="form-control"
												v-model="form.address_region_id"
												@change="
													regionChanged()
													hasChanges = true
												"
												:class="{ 'is-invalid': validationErrors['data.address_region_id'] }"
											>
												<option value="0">Departamento</option>
												<option v-for="region in regions" :key="region.id" :value="region.id">{{ region.name }}</option>
											</select>
											<div class="invalid-feedback">{{ validationErrors['data.address_region_id'] }}</div>
										</div>
									</div>
									<div class="col-lg-12">
										<div class="form-group">
											<!-- <label>Localidad </label> -->
											<select
												class="form-control"
												v-model="form.address_locality_id"
												:disabled="loadingLocalities"
												@change="hasChanges = true"
												:class="{ 'is-invalid': validationErrors['data.address_locality_id'] }"
											>
												<option value="0">Barrio o localidad</option>
												<option v-for="locality in localities" :key="locality.id" :value="locality.id">{{
													locality.name
												}}</option>
											</select>
											<small v-if="loadingLocalities">Cargando localidades...</small>
											<div class="invalid-feedback">{{ validationErrors['data.address_locality_id'] }}</div>
										</div>
									</div>
									<div class="col-6">
										<div class="form-group">
											<!-- <label>Calle</label> -->
											<input
												type="text"
												class="form-control"
												placeholder="Calle"
												v-model="form.address_street"
												@change="hasChanges = true"
												:class="{ 'is-invalid': validationErrors['data.address_street'] }"
											/>
											<div class="invalid-feedback">{{ validationErrors['data.address_street'] }}</div>
										</div>
									</div>
									<div class="col-3 pl-0">
										<div class="form-group">
											<!-- <label>Número</label> -->
											<input
												type="text"
												class="form-control"
												placeholder="Número"
												v-model="form.address_number"
												@change="hasChanges = true"
												:class="{ 'is-invalid': validationErrors['data.address_number'] }"
											/>
											<div class="invalid-feedback">{{ validationErrors['data.address_number'] }}</div>
										</div>
									</div>
									<div class="col-3 pl-0">
										<div class="form-group">
											<!-- <label>Número</label> -->
											<input type="text" class="form-control" v-model="form.address_comments" @change="hasChanges = true" />
											<small class="text-secondary"> opcional</small>
										</div>
									</div>
								</div>

								<div class="row">
									<label>Datos de ingreso</label>
								</div>

								<div class="row">
									<div class="col-lg-12">
										<div class="form-group">
											<!-- <label>Email</label> -->
											<input
												type="email"
												class="form-control"
												placeholder="Correo electrónico"
												v-model="form.email"
												:class="{ 'is-invalid': validationErrors['data.email'] }"
											/>
											<div class="invalid-feedback">{{ validationErrors['data.email'] }}</div>
										</div>
									</div>
									<div class="col-lg-12">
										<div class="form-group">
											<!-- <label>Email</label> -->
											<input
												type="email"
												class="form-control"
												placeholder="Repetir correo electrónico"
												v-model="form.emailConfirm"
												:class="{ 'is-invalid': validationErrors['data.emailConfirm'] }"
											/>
											<div class="invalid-feedback">{{ validationErrors['data.emailConfirm'] }}</div>
										</div>
									</div>
								</div>

								<div class="row">
									<!-- <label class="ml-3">CONTRASEÑA</label> -->
									<div class="col-lg-12">
										<div class="form-group">
											<div class="input-float-button" @click="showPassword = !showPassword">
												<i class="" :class="this.showPassword ? 'icon-eye-off' : 'icon-eye'"></i>
											</div>
											<input
												:type="this.showPassword ? 'text' : 'password'"
												class="form-control"
												placeholder="Contraseña"
												v-model="form.password"
												:class="{ 'is-invalid': validationErrors['data.password'] }"
											/>
											<password v-model="form.password" @score="passwordScore" :strength-meter-only="true" />
											<div class="invalid-feedback">{{ validationErrors['data.password'] }}</div>
										</div>
									</div>
									<div class="col-lg-12">
										<div class="form-group">
											<div class="input-float-button" @click="showPassword = !showPassword">
												<i class="" :class="this.showPassword ? 'icon-eye-off' : 'icon-eye'"></i>
											</div>
											<input
												:type="this.showPassword ? 'text' : 'password'"
												class="form-control"
												placeholder="Repetir contraseña"
												v-model="form.passwordConfirm"
												:class="{ 'is-invalid': validationErrors['data.passwordConfirm'] }"
											/>
											<div class="invalid-feedback">{{ validationErrors['data.passwordConfirm'] }}</div>
										</div>
									</div>
								</div>

								<div class="row">
									<div class="col-lg-12">
										<div class="form-group form-check">
											<input
												type="checkbox"
												class="form-check-input"
												id="disclaimer"
												v-model="form.disclaimer"
												:class="{ 'is-invalid': validationErrors['disclaimer'] }"
											/>
											<label class="form-check-label" for="disclaimer">Acepto los términos y condiciones</label>
											<div class="invalid-feedback">{{ validationErrors['disclaimer'] }}</div>
										</div>
									</div>
								</div>

								<div class="">
									<input type="submit" class="btn_1 medium" value="Registrarme" v-if="!loading" />
									<div class="btn_1 medium" v-else>
										Registrando...
									</div>
								</div>
								<div class="text-center">
									<small>
										Al crear una cuenta, declaro que soy mayor de edad y acepto los
										<router-link tag="a" to="/terms"> Términos y condiciones</router-link> y las
										<router-link tag="a" to="/privacy"> Políticas de privacidad </router-link> de DoctorConsultas
									</small>
								</div>
							</form>
						</div>
						<p class="text-center link_bright">
							¿Ya estas registrado? <router-link tag="a" to="/login"><strong>Ingresar!</strong></router-link>
						</p>
						<!-- /box_form -->
					</div>
					<!-- /col -->
				</div>
				<!-- /row -->
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { onLogin } from '../vue-apollo'
import { mapMutations } from 'vuex'

import Navigation from '@/components/Navigation'
import Footer from '@/components/Footer'
import Password from 'vue-password-strength-meter'

export default {
	name: 'Register',
	metaInfo: {
		title: 'Registrarme',
	},
	components: {
		Navigation,
		Footer,
		Password,
	},
	data() {
		return {
			form: {
				name: '',
				lastname: '',
				email: '',
				emailConfirm: '',
				phone: '',
				password: '',
				passwordConfirm: '',
				doc_type: 'CI',
				doc_number: '',
				address_region_id: null,
				address_locality_id: null,
				address_country_id: null,
				address_country_iso: null,
				address_comments: '',
			},
			validationErrors: {},
			showPassword: false,
			loading: false,
			passwordStrength: 0,
			loadingCountries: false,
			loadingLocalities: false,
			countries: [],
			regions: [],
			localities: [],
		}
	},
	beforeMount() {
		this.logout()
		this.loadRegions()
	},
	methods: {
		...mapMutations(['authSuccess', 'logout']),
		passwordScore(score) {
			this.passwordStrength = score
		},
		loadRegions() {
			this.loadingCountries = true
			this.$apollo
				.query({
					query: gql`
						query getLocalities($count: Int!) {
							countries {
								id
								iso
								name
							}
							regions(count: $count) {
								data {
									id
									name
								}
							}
						}
					`,
					variables: {
						count: 100,
					},
				})
				.then((data) => {
					this.countries = data.data.countries
					this.regions = data.data.regions.data
					// selecciono uruguay por defecto
					this.searchCountryByCode('UY')
					this.loadingCountries = false
				})
		},
		searchCountryByCode(code) {
			const index = this.countries.findIndex((c) => c.iso == code)
			if (index >= 0) {
				this.form.address_country_id = this.countries[index].id
				this.countryChanged()
			}
		},
		
		countryChanged() {
			const countryIndex = this.countries.findIndex((c) => c.id == this.form.address_country_id)
			if (countryIndex >= 0) {
				this.form.address_country_iso = this.countries[countryIndex].iso
			} else {
				this.form.address_country_iso = null
			}
		},

		loadLocalities(regionId) {
			this.localities = []
			this.loadingLocalities = true
			this.$apollo
				.query({
					query: gql`
						query getLocalities($count: Int!, $regionId: ID!) {
							localities(count: $count, regionId: $regionId) {
								data {
									id
									name
								}
							}
						}
					`,
					variables: {
						count: 100,
						regionId: regionId,
					},
				})
				.then((data) => {
					this.localities = data.data.localities.data
					this.loadingLocalities = false
				})
		},
		regionChanged() {
			this.form.address_locality_id = 0
			this.loadLocalities(this.form.address_region_id)
		},
		validateCI() {
			this.hasChanges = true
			this.validationErrors = {}

			if (this.form.doc_type == 'CI' && !this.validate_ci(this.form.doc_number)) {
				this.validationErrors['data.doc_number'] = 'Ingrese una cédula válida'
			}
			if (this.form.doc_type == 'Passport' && this.form.doc_number.length <= 4) {
				this.validationErrors['data.doc_number'] = 'Ingrese un documento válido'
			}
		},
		validation_digit(ci) {
			var a = 0
			var i = 0
			if (ci.length <= 6) {
				for (i = ci.length; i < 7; i++) {
					ci = '0' + ci
				}
			}
			for (i = 0; i < 7; i++) {
				a += (parseInt('2987634'[i]) * parseInt(ci[i])) % 10
			}
			if (a % 10 === 0) {
				return 0
			} else {
				return 10 - (a % 10)
			}
		},
		validate_ci(ci) {
			if (!ci) {
				return false
			}
			ci = this.clean_ci(ci)
			var dig = ci[ci.length - 1]
			ci = ci.replace(/[0-9]$/, '')
			return dig == this.validation_digit(ci)
		},
		random_ci() {
			var ci = Math.floor(Math.random() * 10000000).toString()
			ci = ci.substring(0, 7) + this.validation_digit(ci)
			return ci
		},
		clean_ci(ci) {
			return ci.replace(/\D/g, '')
		},
		register() {
			if (!this.loading) {
				this.validationErrors = {}

				if (this.validate()) {
					this.loading = true


					var dataInput = {
						name: this.form.name,
						lastname: this.form.lastname,
						phone: this.form.phone,
						email: this.form.email,
						emailConfirm: this.form.emailConfirm,
						password: this.form.password,
						passwordConfirm: this.form.passwordConfirm,
						doc_type: this.form.doc_type,
						doc_number: this.form.doc_number,

						address_country_id: this.form.address_country_id,
						address_locality_id: this.form.address_locality_id,
						address_street: this.form.address_street,
						address_number: this.form.address_number,
						address_comments: this.form.address_comments,
					}

					this.$apollo
						.mutate({
							mutation: gql`
								mutation($data: UserRegisterInput!) {
									userRegister(data: $data) {
										id
									}
								}
							`,
							variables: {
								data: dataInput,
							},
						})
						.then(() => {
							this.loading = false
							this.$ga.event('users', 'user-registered', this.form.email)
							this.login()
						})
						.catch((error) => {
							let { graphQLErrors } = error
							if (graphQLErrors[0].extensions.category === 'validation') {
								this.validationErrors = this.parseErrors(graphQLErrors[0].extensions.validation)
							} else {
								this.validationErrors['general'] = 'Se ha producido un error'
							}
							this.loading = false
						})
				}
			}
		},
		validate() {
			let error = false
			this.validationErrors = {}

			if (!this.form.disclaimer) {
				error = true
				this.validationErrors['disclaimer'] = 'Debe aceptar los términos y condiciones para completar el registro.'
			}

			if (!this.form.name || this.form.name.length <= 0 || this.form.name.length > 20) {
				error = true
				this.validationErrors['data.name'] = 'Ingrese su nombre'
			}
			if (!this.form.lastname || this.form.lastname.length <= 0 || this.form.lastname.length > 20) {
				error = true
				this.validationErrors['data.lastname'] = 'Ingrese su apellido'
			}
			if (!this.form.phone || this.form.phone.length <= 8 || this.form.phone.length > 16) {
				error = true
				this.validationErrors['data.phone'] = 'Ingrese su teléfono celular'
			}
			if (!this.form.email || !this.validateEmail(this.form.email)) {
				error = true
				this.validationErrors['data.email'] = 'Ingrese un email válido'
			}
			if (this.form.email != this.form.emailConfirm) {
				error = true
				this.validationErrors['data.emailConfirm'] = 'Los correos electrónicos no coinciden'
			}

			if (!this.form.doc_type || this.form.doc_number.length <= 4) {
				error = true
				this.validationErrors['data.doc_number'] = 'Ingrese un documento válido'
			}

			if (this.form.doc_type == 'CI' && !this.validate_ci(this.form.doc_number)) {
				error = true
				this.validationErrors['data.doc_number'] = 'Ingrese una cédula válida'
			}
			if (this.form.doc_type == 'Passport' && this.form.doc_number.length <= 4) {
				error = true
				this.validationErrors['data.doc_number'] = 'Ingrese un documento válido'
			}

			// console.log(this.form.address_region_id)
			if (!this.form.address_country_id) {
				error = true
				this.validationErrors['data.address_country_id'] = 'Seleccione su país de residencia'
			}

			if (this.form.address_country_id == 226) {
				//uruguay
				if (!this.form.address_region_id || this.form.address_region_id <= 0) {
					error = true
					this.validationErrors['data.address_region_id'] = 'Seleccione su departamento'
				}

				if (!this.form.address_locality_id || this.form.address_locality_id <= 0) {
					error = true
					this.validationErrors['data.address_locality_id'] = 'Seleccione su barrio o localidad'
				}

				if (!this.form.address_street || this.form.address_street.length <= 2) {
					error = true
					this.validationErrors['data.address_street'] = 'Ingrese su calle'
				}

				if (!this.form.address_number || this.form.address_number.length < 2) {
					error = true
					this.validationErrors['data.address_number'] = 'Ingrese su numero de puerta'
				}
			}

			if (!this.form.password) {
				error = true
				this.validationErrors['data.password'] = 'Ingrese su contraseña'
			}
			if (this.passwordStrength < 2) {
				error = true
				this.validationErrors['data.password'] = 'La contraseña es muy debil'
			}
			if (!this.form.passwordConfirm || this.form.passwordConfirm.length <= 6 || this.form.passwordConfirm.length > 16) {
				error = true
				this.validationErrors['data.passwordConfirm'] = 'Confirme su contraseña'
			}

			if (this.form.password != this.form.passwordConfirm) {
				error = true
				this.validationErrors['data.passwordConfirm'] = 'Las contraseñas no coinciden'
			}

			if (!error) {
				return true
			}
			return false
		},
		parseErrors(errors) {
			let parsedErrors = []
			Object.keys(errors).forEach((key) => {
				parsedErrors[key] = errors[key][0]
			})
			return parsedErrors
		},
		validateEmail(email) {
			var re = /\S+@\S+\.\S+/
			return re.test(String(email).toLowerCase())
		},

		login() {
			// console.log('login', this.form.email, this.form.password);
			axios
				.post('/auth/user/login', { email: this.form.email, password: this.form.password })
				.then((request) => {
					let access_token = request.data.access_token
					let logged_user = request.data.user
					onLogin(this.$apollo.provider.defaultClient, access_token, logged_user).then(() => {
						// console.log('onlogin then')
						this.authSuccess({ token: access_token, loggedUser: logged_user })
						this.$router.push('/')
					})
				})
				.catch(() => {
					this.loginFailed()
				})
		},
	},
}
</script>

<style scoped>
#hero_register {
	color: #5a5d5c;
}
#hero_register h1 {
	color: #5a5d5c;
}
@media (max-width: 767px) {
	#hero_register h1 {
		/* For less than 767px */
		font-size: 32px;
		font-size: 2rem;
	}
}

#register {
	margin: 60px auto;
	color: #fff;
}

#register h1 {
	font-size: 28px;
	font-size: 1.75rem;
	text-align: center;
	margin: 0 0 30px 0;
	color: #fff;
}

#login {
	width: 400px;
	margin: 60px auto;
	color: #fff;
}

@media (max-width: 767px) {
	#login {
		/* For less than 767px */
		width: 100%;
		margin: 30px 0;
	}
}

#login h1 {
	font-size: 28px;
	font-size: 1.75rem;
	text-align: center;
	margin: 0 0 30px 0;
	color: #fff;
}

@media (max-width: 767px) {
	#login h1 {
		/* For less than 767px */
		font-size: 21px;
		font-size: 1.3125rem;
	}
}

.divider {
	text-align: center;
	height: 1px;
	margin: 30px 0;
	background-color: #e1e8ed;
}

.divider span {
	position: relative;
	top: -20px;
	background-color: #fff;
	display: inline-block;
	padding: 10px;
	font-style: italic;
}

#login-2 {
	width: 650px;
	margin: 60px auto;
	color: #fff;
}

#login-2 .box_form {
	padding: 30px 0 0 0;
}

.box_form .form-group {
	margin-bottom: 1rem;
}

@media (max-width: 767px) {
	#login-2 .box_form {
		/* For less than 767px */
		padding: 20px 20px 0 20px;
	}
}

#login-2 .forgot {
	display: inline-block;
	margin-top: 5px;
}

@media (max-width: 767px) {
	#login-2 {
		/* For less than 767px */
		width: 100%;
		margin: 0;
	}
}

#login-2 h1 {
	font-size: 28px;
	font-size: 1.75rem;
	text-align: center;
	margin: 0 0 30px 0;
	color: #fff;
}

.box_login {
	width: 50%;
	float: left;
	border-right: 1px solid #e1e8ed;
	padding: 15px 25px;
}

@media (max-width: 767px) {
	.box_login {
		/* For less than 767px */
		width: 100%;
		border-right: 0;
		padding: 0;
	}
}

.box_login.last {
	border-right: 0;
}

a.social_bt {
	-webkit-border-radius: 3px;
	-moz-border-radius: 3px;
	-ms-border-radius: 3px;
	border-radius: 3px;
	text-align: center;
	color: #fff;
	min-width: 200px;
	margin-bottom: 15px;
	display: block;
	padding: 12px;
	line-height: 1;
	position: relative;
	-moz-transition: all 0.3s ease-in-out;
	-o-transition: all 0.3s ease-in-out;
	-webkit-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out;
	cursor: pointer;
}

a.social_bt:hover {
	-webkit-filter: brightness(115%);
	filter: brightness(115%);
}

a.social_bt.facebook:before,
a.social_bt.google:before,
a.social_bt.linkedin:before {
	font-family: 'ElegantIcons';
	position: absolute;
	left: 12px;
	top: 10px;
	font-size: 1rem;
	color: #fff;
}

a.social_bt.facebook {
	background-color: #3b5998;
}

a.social_bt.facebook:before {
	content: '\e093';
}

a.social_bt.google {
	background-color: #dc4e41;
}

a.social_bt.google:before {
	content: '\e096';
	top: 12px;
}

a.social_bt.linkedin {
	background-color: #0077b5;
}

a.social_bt.linkedin:before {
	content: '\e09d';
}

.box_feat_2 {
	position: relative;
	padding-left: 60px;
}
.box_feat_2 h3 {
	font-size: 18px;
	font-size: 1.125rem;
	color: #fff02a;
}
.box_feat_2 i {
	font-size: 46px;
	font-size: 2.875rem;
	margin-bottom: 10px;
	color: #74d1c6;
	position: absolute;
	left: 0;
	top: 0;
}

.btn_1 {
	display: table;
	margin: auto;
}
</style>
